module.exports = __webpack_public_path__ + "static/media/butterchicken.e86f4413.jpg";